import { Button } from '@/components';
import { env } from '@/config/env';
import { cn } from '@/utils';

import GoogleIcon from '../../assets/google-icon';

const GoogleSignUpButton = ({
  className,
  deepLink,
}: {
  className?: string;
  deepLink?: string;
}) => {
  const handleClick = () => {
    let googleUrl = `${env.API_URL}/user/v1/google-login?return_url=${env.APP_URL}`;
    if (deepLink) {
      googleUrl = `${googleUrl}/${deepLink}`;
    }
    globalThis.location.replace(googleUrl);
  };

  return (
    <Button
      type="button"
      variant="outline"
      className={cn('w-full', className)}
      icon={<GoogleIcon />}
      iconPosition="start"
      onClick={handleClick}
    >
      Sign up with Google
    </Button>
  );
};

export default GoogleSignUpButton;
